import React, { ChangeEvent, useContext, useEffect, useRef, useState } from 'react'
import { Button, ButtonGroup, MenuItem, Paper, Portal, Select, makeStyles } from '@cicero/ui'
import { ReactEditor } from 'slate-react'
import { Editor, Range } from 'slate'
import { EditorContext } from '../EditorService'
import { ContentCommands } from '../commands'

export const ActiveSelectionToolbelt = () => {
  const ref = useRef<HTMLElement>(null)
  const service = useContext(EditorContext)
  const [textLevel, setTextLevel] = useState('text')
  const { menu } = styles()

  useEffect(() => {
    const el = ref.current
    const { selection } = service.editor

    if (!el) { return }
    if (!selection || !ReactEditor.isFocused(service.editor) || Range.isCollapsed(selection) || Editor.string(service.editor, selection) === '') {
      el.removeAttribute('style')
      return
    }

    const domSelection = window.getSelection()
    const domRange = domSelection?.getRangeAt(0)
    const rect = domRange?.getBoundingClientRect()
    el.style.opacity = '1'
    el.style.top = `${(rect?.top || 0) + window.pageYOffset - el.offsetHeight}px`
    el.style.left = `${(rect?.left || 0) + window.pageXOffset - (el.offsetWidth / 2) + (rect?.width || 1 / 2)}px`
  })

  useEffect(() => {
    const contentSub = service.state.currentFragment$.subscribe((content: any) => {
      if (content.length) { content = content[0] }
      if (content) {
        const { children } = content
        if (children && children.length) { setTextLevel(children[0].level || 'text') }
      }
    })

    return () => {
      contentSub.unsubscribe()
    }
  })

  return <Portal>
    <Paper ref={ref} className={menu}>
      <ButtonGroup>
        <Button onMouseDown={ev => { ev.preventDefault(); ContentCommands.toggleBold(service.editor) }}>B</Button>
        <Button onMouseDown={ev => { ev.preventDefault(); ContentCommands.toggleItalic(service.editor) }}>I</Button>
        <Button onMouseDown={ev => { ev.preventDefault(); ContentCommands.toggleUnderline(service.editor) }}>U</Button>
        <Button onMouseDown={ev => { ev.preventDefault(); ContentCommands.clearFormatting(service.editor) }}>C</Button>
        {/* <Button onClick={() => }>Comment</Button> */}
      </ButtonGroup>
      <Select
        id="text-level-select"
        value={textLevel}
        onChange={(ev: ChangeEvent<any>) => { setTextLevel(ev.target.value); ContentCommands.setParagraphLevel(service.editor, ev.target.value) }}
      >
        <MenuItem value="text">Text</MenuItem>
        <MenuItem value="h1">Heading 1</MenuItem>
        <MenuItem value="h2">Heading 2</MenuItem>
        <MenuItem value="h3">Heading 3</MenuItem>
      </Select>
    </Paper>
  </Portal>
}

const styles = makeStyles({
  menu: {
    opacity: 0,
    position: 'absolute',
    zIndex: 1,
    transition: 'all ease-in-out .5s',
  },
})
